// The mobile navbar button.
//
// On desktop the assistant opens from the sidebar (AiSidebarButton); the
// mobile layout has no sidebar, so this pill in the navbar is the entry point
// there. Just the button: the panel is mounted once by AiPanelHost in the
// layout.
//
// Labelled "AI" rather than left as a bare glyph. A sparkle on its own next to
// a bell and a question mark does not tell anyone what it opens.
//
// Two conditions gate it, and both matter:
//   1. The customer is signed in — without a token there is no account to
//      answer about.
//   2. The AI service accepts that token. It is a separate deployment from the
//      portal API, so it can be down or not yet rolled out while the rest of
//      the page works fine. AiPanelHost makes that check once.

import React from "react";
import { AiIcon } from "icons/header/AiIcon";
import { useAppDispatch } from "store/hooks";
import { setAiOpen, useAiState } from "store/slices/aiSlice";
import { useUserData } from "store/slices/authSlice";

const AiLauncher = () => {
  const dispatch = useAppDispatch();
  const userData = useUserData();
  const { available, open } = useAiState();

  if (!userData?.token || !available) return null;

  return (
    <button
      type="button"
      onClick={() => dispatch(setAiOpen(!open))}
      aria-label="Open assistant"
      aria-expanded={open}
      className={`flex items-center gap-1.5 pl-2 pr-2.5 py-1.5 rounded-md border cursor-pointer transition-colors ${
        open
          ? "bg-bgSecondary border-blue"
          : "border-strokePrimary hover:!bg-bgSecondary"
      }`}
    >
      <AiIcon
        width={18}
        height={18}
        strokeColor={open ? "var(--color-blue)" : "var(--color-icon-obscure)"}
      />
      <span
        className={`text-sm font-semibold leading-none ${
          open ? "text-blue" : "text-txtPrimary"
        }`}
      >
        AI
      </span>
    </button>
  );
};

export default AiLauncher;
